import Reference from './Reference';

const Destination = props => {
  return <Reference {...props} />;
};

export default Destination;
